@if (orderTypes?.length > 0) {
  <label  class="form-group">
    <span class="label-content">{{ 'cartAdministration.orderTypeSelect.label' | cxTranslate }}</span>
    @if (myName === 'loginOrderTypeSelection') {
      <div class="order-type-selection">
        <ng-select
          [searchable]="false"
          [clearable]="false"
          [readonly]="orderTypes?.length === 1"
          [(ngModel)]="selectedOrderType"
          (change)="orderTypeChange($event)">
          @for (orderType of orderTypes; track orderType) {
            <ng-option [value]="orderType">
              {{ orderType.name }}
            </ng-option>
          }
        </ng-select>
      </div>
    }
    @if (myName === 'cartOrderTypeSelection') {
      <div [class.d-flex]="isLogin" [formGroup]="orderTypeSelectionForm">
        <select class="form-control"
          [name]="myName"
          formControlName="orderTypeCode"
          (change)="orderTypeInFormChange()">
          @for (orderType of orderTypes; track orderType) {
            <option
              [value]="orderType.id">
              {{ orderType.name }}
            </option>
          }
        </select>
        @if (isLogin) {
          <cx-icon [type]="iconTypes.CARET_DOWN"></cx-icon>
        }
      </div>
    }
  </label>
}
